import produce from 'immer';
import { combineReducers } from 'redux-immer';
import { user } from './user';

export const rootReducer = combineReducers(produce, {
  user,
});
